/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/prefer-default-export */

import React, { memo, useCallback } from 'react';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { Alert, Button, Row } from 'reactstrap';
import Pagination from 'rc-pagination';

import del from '../../../../Res/Icon/delete.png';
import edit from '../../../../Res/Icon/edit.png';

import DownloadIcon from '../../../../Res/Icon/download.png';
import DeleteIcon from '../../../../Res/Icon/cancel.png';
import AnalyzingIcon from '../../../../Res/Icon/analyzing.png';
import PinnedIcon from '../../../../Res/Icon/pinned.png';
import UnPinnedIcon from '../../../../Res/Icon/un-pinned.png';
import { ENG_LOCALE } from '../../../../lib/constants';
import AnalyzerModal from './AnalyzerModal';
import { useState } from 'react';
import SortIcons from '../../../ProposalsSortIcons';
import utils from '../../../../lib/utils';
import './index.styles.css';

import Spinner from '../../../Spinner/Spinner';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import { useUnifiedFetch } from '../../../../hooks/useUnifiedFetch';
// import filterIcon from '../../../../Res/Icon/filter.png';

export const NotesTable = memo(
  ({
    handleEditNote,
    onEditNote,
    boxNotes,
    setBoxNotes,
    onDownload,
    handleDeleteNote,
    handleChangePagination,
    onPageChange,
    shouldFilter,
    user,
    onDeleteRecording,
    updateFetchQuery,
    box,
    onSort,
    sortValue,
    selectedTab
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [note, setNote] = useState(null);
    const [file, setFile] = useState(null);
    const [isLoaderOpen, setIsLoaderOpen] = useState(false); // Add this state variable
    const [showConvertModal, setShowConvertModal] = useState(false);
    const [pendingAnalyzeBox, setPendingAnalyzeBox] = useState(null);

    const convertFetch = useUnifiedFetch('obis/convertPcapToWav', false);


    const handlePinnedRecording = async e => {
      const { docs } = boxNotes;
      let totalPinned = 0;
      docs.forEach(pin => {
        pin.pinned && (totalPinned += 1);
      });
      if (e.pinned) {
        await onEditNote({ ...e, pinned: !e.pinned }, e._id);
        await updateFetchQuery();
      } else if (totalPinned < 5) {
        await onEditNote({ ...e, pinned: !e.pinned }, e._id);
        await updateFetchQuery();
      } else {
        toast.error("You can't pin more than 5 recordings.");
      }
    };

    const onDownloadAttachment = useCallback((e, name) => {
      onDownload(e, name);
    }, []);

      const analyzeAudio = async note => {
        try {
          setIsLoaderOpen(true); // Set to true when starting to load
          let res = await onDownload(note._id, note.attachment.name, true);
          if(res) {
            setNote(note);
            setFile(res);
            setIsOpen(true);
          } else {
            toast.error('File does not exist');
          }
          
        } catch (error) {
          console.error('Error analyzing audio:', error);
        } finally {
          
          setIsLoaderOpen(false); // Set back to false when analysis is done (success or failure)
        }
      };

    const handleAnalyzeClick = (box) => {
      // If the file is a .pcap, show the convert modal
      if (box.attachment?.name?.endsWith('.pcap')) {
        setPendingAnalyzeBox(box);
        setShowConvertModal(true);
      } else {
        analyzeAudio(box);
      }
    };

    const handleConfirmConvert = async () => {
      setShowConvertModal(false);
      if (!pendingAnalyzeBox) return;
      setIsLoaderOpen(true);
      try {
        const response = await convertFetch.fetchData({ noteId: pendingAnalyzeBox._id }, 'GET', null, 'blob');

        // Check if the response indicates an error
        if (response && response.status === false) {
          toast.error('File conversion failed');
          setIsLoaderOpen(false);
          setPendingAnalyzeBox(null);
          return;
        }
        
        // Update the attachment name from .pcap to .wav after successful conversion
        const updatedAttachment = {
          ...pendingAnalyzeBox.attachment,
          name: pendingAnalyzeBox.attachment.name.replace('.pcap', '.wav')
        };
        
        const updatedNote = {
          ...pendingAnalyzeBox,
          attachment: updatedAttachment
        };
        
        // Update the local state to reflect the change immediately
        const updatedDocs = boxNotes.docs.map(doc => 
          doc._id === pendingAnalyzeBox._id ? updatedNote : doc
        );
        
        setBoxNotes({
          ...boxNotes,
          docs: updatedDocs
        });
        
        // If not error, treat as valid file
        setNote(pendingAnalyzeBox);
        setFile(response);
        setIsOpen(true);
      } catch (error) {
        toast.error('Conversion failed: ' + error.message);
      } finally {
        setIsLoaderOpen(false);
        setPendingAnalyzeBox(null);
      }
    };

    const handleCancelConvert = () => {
      setShowConvertModal(false);
      setPendingAnalyzeBox(null);
    };

    const handleAnalyzerModalClose = () => {
      setIsOpen(false);
    };

    return (
      <div className="viewContainer">
        <div className="table-header-fixed">
          <table>
            <thead>
              <tr>
                <th />
                <th onClick={() => onSort('email')}>
                 {selectedTab === '2' ? 'Initiated By' : 'Email'} <SortIcons sortObj={sortValue} sortName="email" />
                </th>
                <th onClick={() => onSort('note')}>
                  Note <SortIcons sortObj={sortValue} sortName="note" />
                </th>
                <th onClick={() => onSort('type')}>
                  Type <SortIcons sortObj={sortValue} sortName="type" />
                </th>
                <th onClick={() => onSort('createdAt')}>
                  Time <SortIcons sortObj={sortValue} sortName="createdAt" />
                </th>
                <th>Attachment</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {boxNotes?.length !== 0 && boxNotes?.docs?.length !== 0 ? (
                boxNotes?.docs?.map((box) => {
                  // To check if content is parseable (e.g., as JSON), you can use a try-catch block.
                  // Here is a utility function for JSON parseability:
                  const isParseableJSON = (content) => {
                    try {
                      JSON.parse(content);
                      return true;
                    } catch (e) {
                      return false;
                    }
                  };
                  let note = isParseableJSON(box.note) ? JSON.parse(box.note) : box.note;

                  return (
                  <tr key={Math.random().toString()}>
                    <td>
                      <Button
                        style={{ background: 'inherit', border: 'none', display: 'flex' }}
                        onClick={() => handlePinnedRecording(box)}
                        title={box.pinned ? 'Unpin Recording' : 'Pin Recording'}
                      >
                        <img
                          style={{ height: '20px' }}
                          src={box.pinned ? PinnedIcon : UnPinnedIcon}
                          alt="..."
                        />
                      </Button>
                    </td>
                    {/* <td>{(box.user && box?.user?.role === 'epikBox' ) ? 'System': box.user ? box.user.email : '-'}</td> */}
                    <td>
                      {box?.user?.role === 'epikBox'
                        ? 'System'
                        : box.user
                          ? box.user.email
                          : box.type === 'system'
                            ? 'system'
                            : '-'}
                    </td>
                      <td style={{ 
                        whiteSpace: 'pre-line', 
                        wordBreak: 'break-word',
                        color: box.type === 'EPI' ? 'red' : 'inherit',
                        padding: box.type === 'EPI' ? '8px' : 'inherit',
                        borderRadius: box.type === 'EPI' ? '4px' : 'inherit',
                        fontWeight: box.type === 'EPI' ? 500 : 'inherit'
                      }}>
                        {isParseableJSON(box.note) ? Object.keys(note).map((key, idx) => (
                          <p key={idx} style={{ marginTop: 1, marginBottom: 5 }}>
                            <b style={{ textTransform: 'capitalize' }}>{key}:</b>  {JSON.stringify(note[key])}
                          </p>
                        ))
                          : note}
                      </td>
                    {/* <td>{box?.user?.role === 'epikBox' ? 'System' : 'User'}</td> */}
                    <td>
                      {box?.type === 'EPI' ? (
                        <span style={{ color: '#FF0004', fontWeight: 500 }}>EPI</span>
                      ) : (
                        box?.user == null || (box.user.role == 'epikBox' && (box?.note == 'Recording added by epikbox'))
                          ? 'Device'
                          : 'User'
                      )}
                    </td>
                    <td>{utils.getDateTimeFormat(box.createdAt, 'both')}</td>
                    <td>
                      {box.attachment && box.attachment.name && (
                        <div className="attachment-wrapper">
                          <Button
                            style={{ background: 'inherit', border: 'none', display: 'flex' }}
                            onClick={() => onDownloadAttachment(box._id, box.attachment.name)}
                            title="Download"
                          >
                            <img style={{ height: '28px' }} src={DownloadIcon} alt="..." />
                            <p style={{ color: '#000000' }} className="attachment-text">
                              {box.attachment.name}
                            </p>
                          </Button>
                          <Button
                            style={{
                              background: 'inherit',
                              border: 'none',
                              display: 'flex',
                              padding: 0,
                            }}
                            onClick={() => onDeleteRecording(box)}
                            title="Delete"
                          >
                            <img style={{ height: '20px' }} src={DeleteIcon} alt="..." />
                          </Button>
                        </div>
                      )}
                    </td>
                    <td>     {isLoaderOpen && <Spinner />}
                    
                      {(box.attachment && box.attachment.name && selectedTab === '3') && (
                        <Button
                          style={{
                            background: 'inherit',
                            border: 'none',
                            display: 'flex',
                            padding: 0,
                          }}
                          onClick={() => handleAnalyzeClick(box)}
                        >
                          <img style={{ height: '20px' }} src={AnalyzingIcon} alt="..." />
                        </Button>
                      )}
                    </td>
                    <td style={{ display: 'flex' }}>
                      {box.user && user._id === box.user._id ? (
                        <>
                          <img
                            className="actions-icon"
                            src={edit}
                            onClick={() => handleEditNote(box)}
                            alt="edit"
                          />
                          <img
                            className="actions-icon"
                            src={del}
                            onClick={() => handleDeleteNote(box)}
                            alt="delete"
                          />
                        </>
                      ) : null}
                    </td>
                  </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={10}>
                    <Alert rowSpan={10} color="info">
                      No notes added
                    </Alert>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {boxNotes?.totalPages > 1 && (
          <Pagination
            locale={ENG_LOCALE}
            className="pagination-container"
            onChange={shouldFilter ? onPageChange : handleChangePagination}
            current={boxNotes?.page}
            total={boxNotes?.totalDocs}
            pageSize={boxNotes?.limit}
            showLessItems
            showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
          />
        )}
        <ConfirmationModal
          isOpen={showConvertModal}
          onCancel={handleCancelConvert}
          onConfirm={handleConfirmConvert}
          bodyText={
            'This file must be converted before it can be analyzed. Do you want to continue?'
          }
          confirmBtnText="Continue"
          closeBtnText="Cancel"
          headerText="Convert PCAP"
        />
        {isOpen && (
          <AnalyzerModal note={note} file={file} isOpen={isOpen} onClose={handleAnalyzerModalClose} />
        )}
      </div>
    );
  },
);
